import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastService } from '../portal/toast.service';
import { DMS_ADMIN_ONLY_MESSAGE, SessionService } from '../services/session.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);
  if (session.loggedIn()) return true;
  return router.createUrlTree(['/'], {
    queryParams: { login: '1', returnUrl: state.url },
  });
};

/** DMS: same landing login overlay; only Admin (config_admin) may enter. */
export const dmsGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);
  if (!session.loggedIn()) {
    return router.createUrlTree(['/'], {
      queryParams: { login: '1', returnUrl: state.url },
    });
  }
  if (session.canAccessDms()) return true;
  inject(ToastService).showError(DMS_ADMIN_ONLY_MESSAGE);
  return router.createUrlTree(['/']);
};

export const guestGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);
  if (!session.loggedIn()) return true;
  return router.createUrlTree([session.homePath()]);
};

/** Legacy `/login` URLs open the sign-in overlay on the landing page. */
export const loginOverlayRedirectGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);
  if (session.loggedIn()) {
    return router.createUrlTree([session.homePath()]);
  }
  const parsed = router.parseUrl(state.url);
  return router.createUrlTree(['/'], {
    queryParams: {
      login: '1',
      returnUrl: parsed.queryParams['returnUrl'] || null,
    },
  });
};
